import React from 'react';
import { ViewabilityElement } from 'mm-ui-components';
import { sendPageView } from 'mm-client-core';
import { useSelector } from 'react-redux';
import { ArticlePageViewParameters, ConfigPageViewParameters } from '../../templates/utils/articleComponent.utils';
import {
  getAdSlots,
  getDfpProperty,
  getEdition,
  getHeaderBidderPublisherID,
  getLanguage,
  getPageType,
  getSiteName,
} from '../../store/config/config.selectors';
import { getCountryCode } from '../../templates/templates.utils';

interface ArticlePageViewEventProps {
  articlePageViewParameters: ArticlePageViewParameters;
}

export const ArticlePageViewEvent: React.FunctionComponent<ArticlePageViewEventProps> = props => {
  const { children, articlePageViewParameters } = props;
  const siteName = useSelector(getSiteName);
  const language = useSelector(getLanguage);
  const pageType = useSelector(getPageType);
  const property = useSelector(getEdition);
  const adSlots = useSelector(getAdSlots);
  const headerBidderPublisherID = useSelector(getHeaderBidderPublisherID);
  const dfpProperty = useSelector(getDfpProperty);

  const sendPageViewForArticle = React.useCallback(() => {
    const pageParameters: ArticlePageViewParameters & ConfigPageViewParameters = {
      ...articlePageViewParameters,
      siteName,
      language,
      pageType,
      property,
      adSlots,
      headerBidderPublisherID,
      countryCode: getCountryCode(),
      dfpProperty,
      category: null,
    };
    sendPageView(pageParameters);
  }, [adSlots, articlePageViewParameters, dfpProperty, headerBidderPublisherID, language, pageType, property, siteName]);

  return (
    <ViewabilityElement viewabilityCallback={sendPageViewForArticle}>
      {children}
    </ViewabilityElement>
  );
};
